import React, { useState } from 'react';
import './index.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Cars from './pages/Cars';
import Admin from './pages/Admin';
import Toast from './components/Toast';

export const ToastContext = React.createContext(null);

export default function App() {
  const [page, setPage] = useState('home');
  const [toast, setToast] = useState(null);

  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3500);
  };

  return (
    <ToastContext.Provider value={showToast}>
      <Navbar page={page} setPage={setPage} />
      {page === 'home' && <Home setPage={setPage} />}
      {page === 'cars' && <Cars />}
      {page === 'admin' && <Admin />}
      {toast && <Toast message={toast.message} type={toast.type} />}
    </ToastContext.Provider>
  );
}
